import React, {Suspense, useEffect, useRef, useState} from 'react';
import {Canvas} from '@react-three/fiber';
import {Html} from '@react-three/drei';

import panoramaImage1 from '../assets/textures/barcelona_1.jpg';
import panoramaImage2 from '../assets/textures/barcelona_2.jpg';
import preview1 from '../assets/textures/preview_1.jpg';
import preview2 from '../assets/textures/preview_2.jpg';
import SceneRenderer from "./SceneRenderer";
import Preview from "./Preview";
import styles from './Styles.module.scss'
import {ArrowIcon, MapIcon, SoundOffIcon, SoundOnIcon} from "../assets/Icons";
import SideBar from "./SideBar/SideBar";
import InteractiveMap from "./InteractiveMap/InteractiveMap";
import InfoBlock from "./InfoBlock";
import IntroOverlay from "./IntroOverlay";


const PanoramaViewer = () => {
    const [previewIsShown, setPreviewIsShown] = useState(false);
    const [mapIsShown, setMapIsShown] = useState(false);
    const [infoIsShown, setInfoIsShown] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [activeId, setActiveId] = useState(1);
    const [nextSceneId, setNextSceneId] = useState(1);

    const [audioIsPlaying, setAudioIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const [showIntro, setShowIntro] = useState(true);

    const toggleAudioPlayPause = () => {
        const wasPlaying = audioIsPlaying;
        setAudioIsPlaying(!wasPlaying);

        if (!wasPlaying) {
            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
    };

    useEffect(() => {
        const audio = audioRef.current;
        const handlePlay = () => setAudioIsPlaying(true);
        const handlePause = () => setAudioIsPlaying(false);

        audio.addEventListener('play', handlePlay);
        audio.addEventListener('pause', handlePause);

        return () => {
            audio.removeEventListener('play', handlePlay);
            audio.removeEventListener('pause', handlePause);
        };
    }, []);

    const handleTransitionClick = (sceneId) => {
        if (!isTransitioning && activeId !== sceneId) {
            setIsTransitioning(true);
            setNextSceneId(sceneId);
        }
    };

    const previews = [
        { id: 1, url: preview1 },
        { id: 2, url: preview2 }
    ];

    const interactivePoints = [
        { id: 1, coords: { x: 65, y: 73 }, name: 'Христофор Колумб' },
        { id: 2, coords: { x: 14, y: 28 }, name: 'Дворец Гуэль' }
    ];

    const buttonInfo = [
        { onClick: () => setMapIsShown(true), icon: (<MapIcon/>) },
        { onClick: toggleAudioPlayPause, icon: (audioIsPlaying ? <SoundOnIcon/> : <SoundOffIcon/>) }
    ]

    return (
        <div style={{ position: 'relative', width: '100%', height: '100vh', background: 'black', overflow: 'hidden' }}>
            {showIntro && <IntroOverlay onFinished={() => setTimeout(() => setShowIntro(false), 1500)} />}
            <audio ref={audioRef} src={"audio.mp3"} loop preload="auto" />
            <div style={{ height: '100%' }}>
                <Canvas>
                    <Suspense fallback={<Html center>Загрузка панорам...</Html>}>
                        <SceneRenderer
                            textures={[panoramaImage1, panoramaImage2]}
                            isTransitioning={isTransitioning}
                            setIsTransitioning={setIsTransitioning}
                            activeId={activeId}
                            handleTransitionClick={handleTransitionClick}
                            showInfo={() => setInfoIsShown(true)}
                            setActiveSceneId={setActiveId}
                            nextSceneId={nextSceneId}
                        />
                    </Suspense>
                </Canvas>
                {!isTransitioning && <div>
                    {previewIsShown ? (<Preview previews={previews} handleTransitionClick={handleTransitionClick} setPreviewIsShown={setPreviewIsShown}/>) : (<div className={`${styles.previewBlock} ${styles.centerContent}`}><div className={`${styles.arrowContainer} ${styles.upsideDown}`} onClick={() => {setPreviewIsShown(true)}} ><ArrowIcon/></div></div>)}
                    <SideBar buttonsInfo={buttonInfo}/>
                    <InteractiveMap
                        mapIsShown={mapIsShown}
                        points={interactivePoints}
                        handleTransitionClick={handleTransitionClick}
                        onClose={() => setMapIsShown(false)}
                        currentSceneId={activeId}
                    />
                    <InfoBlock text={'Edifici Colón (также Torre Maritima) — офисный небоскреб в Барселоне, Каталония, Испания. Он имеет 28 этажей и возвышается на высоту 110 метров (120 ярдов). Он расположен в районе Сьютат Велья, Авенгуда де лес Драссанес. [1] Построенный в 1970 году, он стал первым небоскребом высотой более 100 метров, построенным в Барселоне.'} isVisible={infoIsShown} onClose={() => setInfoIsShown(false)} />
                </div>}
            </div>
        </div>
    );
};

export default PanoramaViewer;